import { render, staticRenderFns } from "./ClaimBonusButton.vue?vue&type=template&id=6f9f2410"
import script from "./ClaimBonusButton.vue?vue&type=script&lang=js"
export * from "./ClaimBonusButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports